import React from 'react';
import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section
      className="relative pt-24 pb-12 bg-gradient-to-br from-green-900 to-green-800"
      style={{
        backgroundImage: "url('/images/News-Hero-Image.png')",  
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="text-4xl font-bold text-white mb-6">
            News & Events
          </h1>
          <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
            Stay updated with the latest developments in climate finance and sustainability
          </p>
        </motion.div>
      </div>
    </section>
  );
}
